"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VamProduct = exports.VamProductCode = exports.VamProductStatus = void 0;
var VamProductStatus;
(function (VamProductStatus) {
    VamProductStatus["ACTIVE"] = "ACTIVE";
    VamProductStatus["INACTIVE"] = "INACTIVE";
    VamProductStatus["BETA"] = "BETA";
})(VamProductStatus = exports.VamProductStatus || (exports.VamProductStatus = {}));
var VamProductCode;
(function (VamProductCode) {
    VamProductCode["PROJECT_BASIC"] = "PROJECT_BASIC";
    VamProductCode["PROJECT_RFP"] = "PROJECT_RFP";
})(VamProductCode = exports.VamProductCode || (exports.VamProductCode = {}));
var VamProduct;
(function (VamProduct) {
    VamProduct["ADMIN_DASHBOARD"] = "ADMIN_DASHBOARD";
    VamProduct["MARKETPLACE"] = "MARKETPLACE";
    VamProduct["WOLF_SCOUT_EXTENSION"] = "WOLF_SCOUT_EXTENSION";
    VamProduct["SCOUT_DASHBOARD"] = "SCOUT_DASHBOARD";
})(VamProduct = exports.VamProduct || (exports.VamProduct = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFtLXByb2R1Y3QuZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy92YW0tcHJvZHVjdC90eXBlcy92YW0tcHJvZHVjdC5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVILElBQVksZ0JBSVg7QUFKRCxXQUFZLGdCQUFnQjtJQUMxQixxQ0FBaUIsQ0FBQTtJQUNqQix5Q0FBcUIsQ0FBQTtJQUNyQixpQ0FBYSxDQUFBO0FBQ2YsQ0FBQyxFQUpXLGdCQUFnQixHQUFoQix3QkFBZ0IsS0FBaEIsd0JBQWdCLFFBSTNCO0FBRUQsSUFBWSxjQUdYO0FBSEQsV0FBWSxjQUFjO0lBQ3hCLGlEQUErQixDQUFBO0lBQy9CLDZDQUEyQixDQUFBO0FBQzdCLENBQUMsRUFIVyxjQUFjLEdBQWQsc0JBQWMsS0FBZCxzQkFBYyxRQUd6QjtBQUVELElBQVksVUFLWDtBQUxELFdBQVksVUFBVTtJQUNwQixpREFBbUMsQ0FBQTtJQUNuQyx5Q0FBMkIsQ0FBQTtJQUMzQiwyREFBNkMsQ0FBQTtJQUM3QyxpREFBbUMsQ0FBQTtBQUNyQyxDQUFDLEVBTFcsVUFBVSxHQUFWLGtCQUFVLEtBQVYsa0JBQVUsUUFLckIifQ==